import React from "react";
import { Bar } from "react-chartjs-2";

const SalesChart = ({ selectLanguage,graphData }) => {

    const data = {
        labels: [
            "Jan",
            "Feb",
            "Mar",
            "Apr",
            "May",
            "Jun",
            "Jul",
            "Aug",
            "SEPT",
            "OCT",
            "NOV",
            "DEC",
        ],
        datasets: [
            {
                label: `Sales status`,
                backgroundColor: "#F4900C",
                borderColor: "#F4900C",
                borderWidth: 1,
                hoverBackgroundColor: "#F4900C",
                hoverBorderColor: "[#236260]",
                data: graphData,
            },
        ],
    };

    const options = {
        legend: {
          display: false,
        },
        maintainAspectRatio: false,
      };
    
    return (
        <div className="p-4 dashboard-box flex flex-col justify-center items-center border border-gray-200 bg-white shadow-sm col-span-2">
            <p className="text-gray-500 text-sm md:text-md self-start uppercase">
                {selectLanguage === "ar" ? "حالة المبيعات" : "Sales status"}
            </p>

            <div className="chart w-full md:p-5">
                <Bar data={data} height={350} options={options} />
            </div>
        </div>
    );
};

export default SalesChart;
